export * from "./CommonDataService";
export * from "./ICommonDataService";
export * from "./Utils";
export { initUniqueInitialName } from "./UniqueName";
export var CommonDataServiceName = "CommonDataService";
